import { LocationListResponse } from "@opstel/gen/knop/ui/v1/api/location_list_pb";
import { PlainMessage } from "@bufbuild/protobuf";
import { z } from "zod/v3";
import { LocationMetadata, locationmetadataSchema } from "../models/locationMetadata";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";

type Locations = {
  status: ResponseStatus;
  locations: LocationMetadata[];
};
const locationListSchema = createSchema<Locations, PlainMessage<LocationListResponse>>({
  locations: z.array(locationmetadataSchema),
  status: responseStatusSchema,
  message: z.string(),
}) satisfies ZodOutputFor<Locations>;

export function parseLocationList(proto: PlainMessage<LocationListResponse>): LocationMetadata[] {
  return locationListSchema.parse(proto).locations;
}
